import type { ReportLayoutCard } from "@repo/app-types/entities/report";
import { assertUnreachable } from "@repo/app-types/helpers/utilities";
import type { FC } from "react";
import type { ReportDataStreamState } from "../../api/entities/performanceReport.js";
import { ContinuousBarChartCard } from "./continuousBarChartCard.js";
import { DiscreteBarChartCard } from "./discreteBarChartCard.js";
import { HeatMapCard } from "./heatMapCard.js";
import { KeyMetricCard } from "./keyMetricCard.js";
import { ScatterPlotCard } from "./scatterPlotCard.js";
import { TableCard } from "./tableCard.js";
import { TrendLineCard } from "./trendLineCard.js";

interface ReportCardProps {
  card: ReportLayoutCard;
  reportState: ReportDataStreamState | undefined;
  rechartSyncId?: string;
}

export const ReportCard: FC<ReportCardProps> = (props) => {
  const { card, reportState, rechartSyncId } = props;
  const cardEntry = reportState?.data[card.id];

  switch (card.type) {
    case "keyMetric":
      return (
        <KeyMetricCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
          rechartSyncId={rechartSyncId}
        />
      );
    case "heatMap":
      return (
        <HeatMapCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
        />
      );
    case "trendLine":
      return (
        <TrendLineCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
          rechartSyncId={rechartSyncId}
        />
      );
    case "table":
      return (
        <TableCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
        />
      );
    case "continuousBarChart":
      return (
        <ContinuousBarChartCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
        />
      );
    case "discreteBarChart":
      return (
        <DiscreteBarChartCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
        />
      );
    case "scatterPlot":
      return (
        <ScatterPlotCard
          title={card.title}
          data={cardEntry?.cardType === card.type ? cardEntry : undefined}
        />
      );
    default:
      return assertUnreachable(card.type, () => null);
  }
};
